export default __webpack_public_path__ + "img/blue-close.7bbf4778.svg";